// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// project imports
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';
import DarkModeToggle from '../../../../components/DarkModeToggle';

// custom hook
import { useDarkMode } from '../../../../hooks/useDarkMode';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { mode, toggleMode } = useDarkMode();

  return (
    <>
      <Box sx={{ width: '100%', ml: 1 }} />

      <Notification />

      {/* 🌓 DARK MODE TOGGLE SWITCH */}
      <Box sx={{ mr: 1 }}>
        <DarkModeToggle mode={mode} onToggle={toggleMode} />
      </Box>

      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}